import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberRankType } from "./routeType";

const { key, getPath } = getApi("types.memberRank.getAll");

type IExtractedRouteType = IMemberRankType["MemberRankTypeCollectionRetrieve"];

export type IGetMemberRankType = IPickCollectionQuery<IExtractedRouteType>;

const getMemberRankType: Fetcher<
  IGetMemberRankType["response"],
  IGetMemberRankType["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetMemberRankType = createQuery({
  queryKey: [key],
  fetcher: getMemberRankType,
});
